import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from "js-cookie"
// import moment from 'moment';
// moment.locale('ru')


// const WEEK_DAY_NAMES = {  
//   0: 'Пн',
//   1: 'Вт',
//   2: 'Ср',
//   3: 'Чт',
//   4: 'Пт',
//   5: 'Сб',
//   6: 'Вс',
// }

// const DATE_PART_NAMES = {    
//   day: 'День',
//   month: 'Месяц',
//   year: 'Год',
// }

export const serviceApi = createApi({
  reducerPath: 'service',
  baseQuery: fetchBaseQuery({ 
    baseUrl: '/api/',
    prepareHeaders: (headers, { getState, type }) => {
      if(type == 'mutation'){        
        const csrfCookieName = 'csrftoken'
        const csrfCookie = Cookies.get(csrfCookieName)        
        if (csrfCookie) {        
          headers.set(`X-${csrfCookieName}`, csrfCookie)
        }  
      }      
      return headers
    },
    credentials: "include",
  }),  
  endpoints: (builder) => ({    
    getSettings: builder.query({
      query: ({firmId}) => {        
        return {url: `/firm-service-settings/${firmId}/`}
      },
      transformResponse: (response, meta, arg) => {     
        return response.count ? response.results[0] : {}        
      },      
    }),
    getServiceTypes: builder.query({
      query: ({firmId}) => {        
        return {url: `/firm-service-types/${firmId}/`}
      }      
    }),

    getServiceHours: builder.query({
      query: ({firmId, date, find_next_available}) => {
        return {url: `/firm-service-hours/${firmId}/${date}/${find_next_available ? `?find_next_available=1` : ''}`}
      },            
    }),

    getServiceWorkingWeekdays: builder.query({
      query: ({firmId}) => {
        return {url: `/firm-service-working-weekdays/${firmId}/`}
      },
      transformResponse: (response, meta, arg) => {             
        return Object.keys(response).filter((key) => !response[key]).map((key) => parseInt(key) == 6 ? 0 : parseInt(key) + 1 )        
      },
    }),

    

    createServiceRegistration: builder.mutation({
      query({...data}) {
        const body = {...data, send_notifications: true}
        return {
          url: `/firmserviceregistrationcreate/`,
          method: 'POST',
          body,
        }
      },      
      
    }),

  }),
});

export const {  
  useGetServiceTypesQuery,
  useGetServiceHoursQuery,  
  useCreateServiceRegistrationMutation,
  useGetSettingsQuery,
  useGetServiceWorkingWeekdaysQuery
  
} = serviceApi